export const enum SocketEvents {
  CONNECT = "connect",
  DISCONNECT = "disconnect",
  ERROR = "error",

  // Client -> Server
  SEND_MESSAGE_AI = "send_message_ai",
  CLEAN_FORM = "clean_form",
  SEND_FORM_AI = "send_form_ai",
  
  // Server -> Client
  SELECT_TO_USER = "select_to_user",
  FORM_TO_USER = "form_to_user",
  MESSAGE_TO_USER = "message_to_user",
  CHECK_FORM = "check_form",
  ERROR_AI = "error_ai",
}

export type TSendMessageDTO = {
  message: string;
  sessionId: string;
  is_new?: boolean;
  is_ai_resolve_issue?: boolean;
  is_phone_number_entered?: boolean;
  isMobile?: 'True' | 'False';
};

export type TSendFormDTO = {
  fields: {
    email: string;
    phone: string;
    name: string;
  };
  sessionId: string;
};

export type TCheckFormDTO = {
  sessionId: string;
}

export type TFormFields = {
  name: string;
  min?: number;
  max?: number;
  regex: string;
  message: string;
  placeholder: string;
}

export type TFormToUser = {
  message: string;
  fields: TFormFields[];
  lang?: string;
  sessionId: string;
};

export type TMessageToUser = {
  message: string;
  buttons?: string[];
  ai_assistant?: boolean;
  sessionId: string;
};

export type TSelectToUser = {
  options: string[];
  message: string;
  sessionId: string;
};

export type TErrorAI = {
  message: string;
  error: string;
  sessionId: string;
};

export type TServerToClientEvents = {
  [SocketEvents.SELECT_TO_USER]: (data: TSelectToUser) => void;
  [SocketEvents.MESSAGE_TO_USER]: (data: TMessageToUser) => void;
  [SocketEvents.ERROR_AI]: (data: TErrorAI) => void;
  [SocketEvents.FORM_TO_USER]: (data: TFormToUser) => void;
  [SocketEvents.CONNECT]: () => void;
  [SocketEvents.DISCONNECT]: () => void;
  [SocketEvents.ERROR]: (error: string) => void;
};

export type TClientToServerEvents = {
  [SocketEvents.SEND_MESSAGE_AI]: (data: TSendMessageDTO) => void;
  [SocketEvents.CHECK_FORM]: (data: TCheckFormDTO) => void;
  [SocketEvents.CLEAN_FORM]: (data: TCheckFormDTO) => void;
  [SocketEvents.SEND_FORM_AI]: (data: TSendFormDTO) => void;
};
